module.exports = "/_next/static/images/loading_18-084582d60d9a72ac16fe46f95a95cae6.png";